import { IkeConfig } from '../..';
import { IkeLog, IkeLogStreamType, IkeLogType } from '../../../log';
import { LogConfig } from '../log';

export const OfficeBase = new IkeConfig(null, null);

OfficeBase.set('storage.bucket', 'dragon-files');
OfficeBase.set('storage.private.bucket', 'dragon-files-private');
OfficeBase.set('aws.region', 'us-east-1');

/**
 * 30 seconds is the default cloudfront timeout
 * timeouts from the sdk are easier to debug
 * if a request takes longer than this look to optimization
 */
OfficeBase.set('aws.timeout.connect', 60000);
OfficeBase.set('aws.timeout.http', 60000);

OfficeBase.set('database.query.timeout', 15000);
OfficeBase.set('database.query.log.warn', 500);
OfficeBase.set('database.query.log.error', 2500);

OfficeBase.set('auth0.enabled', true);

OfficeBase.set('ike.access.license.cache.enabled', true);
OfficeBase.set('ike.access.license.cache.ttl.seconds', 3600); // 1 hour
OfficeBase.set('ike.access.license.cache.failure.ttl.seconds', 60); // 1 minute for failed/erroring checks

OfficeBase.set('vendor.google.mapsReleaseChannel', 'quarterly');

OfficeBase.set('swagger.enabled', false);

// Verify Workbench (PoleOS) origin. Empty by default (local/offline); the deployed
// envs set their PoleOS origin in the office.<env>.ts files (UFO-148).
OfficeBase.set('verify.workbench.url', '');

LogConfig.register(OfficeBase, IkeLogType.FUNCTION, IkeLog.TRACE, IkeLogStreamType.CONSOLE);
